<div class="sky-card">
  <div class="sky-card-header">
    <h1 class="h2 mb-0">Settings</h1>
  </div>
</div>

<!-- Import -->
<div class="sky-card mt">
  <div class="sky-card-header">
    <h2 class="h3 mb-0">
      <mat-icon>swap_horiz</mat-icon>
      Import / Export
    </h2>
  </div>
  <div class="sky-card-body">
    <div class="container ws-pl">
      Import or export your progression.
      The exported file serves as a backup of all your unlocked items in Sky Planner.
      <div class="sky-flex flex-wrap mt">
        <button type="button" class="item" (click)="import()">
          Import data
        </button>
        <button type="button" class="item" (click)="export()">
          Export data <span class="c-accent">({{unlockedCount}} items)</span>
        </button>
        <button type="button" class="item clear-data" (click)="clear()">
          Clear data
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Date -->
<div class="sky-card mt">
  <div class="sky-card-header">
    <h2 class="h3 mb-0">
      <mat-icon>date_range</mat-icon>
      Date
    </h2>
  </div>
  <div class="sky-card-body">
    <div class="container ws-pl">
      Change the date displayed in the application. Today's date is {{ today | dayjs: dateFormat }}.
      <div class="sky-flex flex-wrap mt">
        <button *ngFor="let format of dateFormats" [class.highlight]="dateFormat === format" type="button" class="item ws-nw" (click)="setDateFormat(format)">
          {{ format | lowercase }}
        </button>
      </div>
    </div>
  </div>

  <!-- Wiki -->
  <div class="sky-card mt">
    <div class="sky-card-header">
      <h2 class="h3">Wiki</h2>
    </div>
    <div class="sky-card-body">
      <div class="container wiki-toggle-tab" (click)="toggleWikiTab()">
        <mat-icon class="menu-icon">{{wikiNewTab ? 'check_box' : 'check_box_outline_blank'}}</mat-icon>
        <span class="menu-label">Navigate to wiki in new tab</span>
      </div>
    </div>
  </div>
</div>
